/* Reversible, scroll-scrubbed pouch opening. No scroll interception,
   timers, dependencies or continuously running animation loop. */
(function () {
  'use strict';
  if (window.bbUnpackInstalled) return;
  window.bbUnpackInstalled = true;

  var scenes = new Map();
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var frame = 0;
  var needsMeasure = true;
  var clamp = function (n) { return Math.max(0, Math.min(1, n)); };
  var phase = function (p, a, b) { return clamp((p - a) / (b - a)); };
  var ease = function (p) { return p * p * (3 - 2 * p); };
  var out = function (p) { return 1 - Math.pow(1 - p, 3); };
  // Asymmetric fan: the centre puff rises first, then the outside pair.
  var flight = [
    { x: -.64, y: -.20, r: -27, delay: .08, size: .95 },
    { x: -.31, y: -.34, r: -12, delay: .02, size: 1.03 },
    { x: .06, y: -.39, r: 9, delay: 0, size: 1.12 },
    { x: .41, y: -.28, r: 23, delay: .055, size: .99 },
    { x: .68, y: -.12, r: 38, delay: .13, size: .84 }
  ];

  function measure(scene) {
    var viewport = window.innerHeight;
    var mobile = window.innerWidth < 900;
    var stageHeight = scene.stage.offsetHeight;
    // Phones: pin the stage centred below the ~80px header. Pinned right under
    // the header, it left an empty band under the bag for the whole scrub.
    var top = mobile
      ? Math.max(92, Math.round((viewport + 80 - stageHeight) / 2))
      : Math.max(92, Math.min(104, viewport * .14));
    var distance = Math.round(Math.max(380, Math.min(mobile ? 560 : 760, viewport * .85)));
    scene.root.style.setProperty('--bb-unpack-top', top + 'px');
    scene.root.style.setProperty('--bb-unpack-stage-height', stageHeight + 'px');
    scene.root.style.setProperty('--bb-unpack-distance', reduce.matches ? '0px' : distance + 'px');
    scene.root.classList.toggle('is-unpack-ready', !reduce.matches);
    var rect = scene.story.getBoundingClientRect();
    scene.start = rect.top + window.scrollY - top;
    scene.distance = distance;
    scene.width = scene.rig.offsetWidth;
    scene.height = scene.rig.offsetHeight;
  }

  function render(scene, p) {
    if (p === scene.last) return;
    scene.last = p;
    var w = scene.width, h = scene.height;
    var makeRoom = ease(phase(p, .08, .7));
    var rip = phase(p, .035, .36);
    // Keep the un-torn end attached. Only lift the entire seal once the
    // right-to-left tear has reached the other side of the pouch.
    var peel = ease(phase(p, .34, .52));
    var mouth = ease(phase(p, .1, .4));
    scene.rig.style.transform = 'translate3d(0,' + (makeRoom * h * .025) + 'px,0) scale(' + (1 - makeRoom * .20) + ')';
    scene.mouth.style.opacity = mouth;
    scene.mouth.style.transform = 'scaleY(' + (.02 + mouth * .98) + ')';
    scene.tear.style.opacity = rip > 0 && rip < 1 ? 1 : 0;
    scene.tearPath.style.strokeDashoffset = 1 - rip;
    scene.seal.style.transform = 'translate3d(' + (peel * w * .26) + 'px,' + (-peel * h * .18) + 'px,0) rotate(' + (-peel * 23) + 'deg)';
    // The food rises during the tear. Its layer stays in front of this
    // strip and behind the pouch front, so the strip never covers a puff.
    scene.seal.style.opacity = 1 - ease(phase(p, .48, .60));
    scene.strips.forEach(function (strip, i) {
      var local = phase(p, .035 + (7 - i) * .025, .19 + (7 - i) * .025);
      strip.style.transform = 'translate3d(0,' + (-ease(local) * h * .016) + 'px,0)';
    });
    scene.pieces.forEach(function (piece, i) {
      var f = flight[i];
      var local = phase(p, .16 + f.delay * .5, .80 + f.delay * .3);
      var travel = out(local);
      var lift = Math.sin(local * Math.PI) * h * .025;
      var x = f.x * w * travel;
      var y = 30 * (1 - travel) + f.y * h * travel - lift;
      var rotation = f.r * ease(local);
      var size = .65 + (f.size - .65) * travel;
      piece.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) rotate(' + rotation + 'deg) scale(' + size + ')';
    });
    scene.sugar.forEach(function (fleck, i) {
      // Fixed irregular spacing keeps the powder organic and exactly
      // reversible. First a mouth burst, then loose sugar falling off puffs.
      var seed = (i * .61803398875) % 1;
      var local, x, y;
      if (i < 48) {
        local = phase(p, .15 + (i % 12) * .013, .86 + (i % 8) * .015);
        var angle = -Math.PI * .92 + seed * Math.PI * .84;
        var radius = (.45 + (i % 9) * .055) * w;
        var travel = out(local);
        x = Math.cos(angle) * radius * travel + Math.sin(local * Math.PI * 2 + i) * w * .018 * local;
        y = Math.sin(angle) * radius * travel + h * .28 * local * local;
      } else {
        local = phase(p, .33 + (i % 8) * .018, .92 + (i % 8) * .007);
        var f = flight[i % flight.length];
        var foodLocal = phase(p, .16 + f.delay * .5, .80 + f.delay * .3);
        var foodTravel = out(foodLocal);
        x = f.x * w * foodTravel + (seed - .5) * w * (.12 + local * .32);
        y = 30 * (1 - foodTravel) + f.y * h * foodTravel - Math.sin(foodLocal * Math.PI) * h * .025
          + h * .12 + h * (.12 + seed * .18) * local * local;
      }
      fleck.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + (.8 + (i % 4) * .25) + ')';
      fleck.style.opacity = local > 0 && local < 1 ? Math.pow(Math.sin(local * Math.PI), .7) * .85 : 0;
    });
    scene.payoff.style.opacity = ease(phase(p, .73, .92));
    scene.payoff.style.transform = 'translate3d(0,' + (8 * (1 - ease(phase(p, .73, .92)))) + 'px,0) rotate(-2deg)';
  }

  function update() {
    frame = 0;
    var scroll = window.scrollY;
    // Read dimensions for all scenes before any animation writes.
    if (needsMeasure) scenes.forEach(measure);
    scenes.forEach(function (scene) {
      render(scene, reduce.matches ? 0 : clamp((scroll - scene.start) / scene.distance));
    });
    needsMeasure = false;
  }
  function schedule() { if (!frame) frame = window.requestAnimationFrame(update); }
  function resize() {
    needsMeasure = true;
    scenes.forEach(function (scene) { scene.last = -1; });
    schedule();
  }
  function init(scope) {
    scope.querySelectorAll('[data-bb-unpack]').forEach(function (root) {
      if (scenes.has(root)) return;
      var stage = root.querySelector('[data-unpack-stage]');
      var scene = {
        root: root, stage: stage, story: stage.parentElement,
        rig: root.querySelector('[data-unpack-rig]'),
        mouth: root.querySelector('[data-unpack-mouth]'),
        seal: root.querySelector('[data-unpack-seal]'),
        strips: Array.from(root.querySelectorAll('[data-unpack-seal-piece]')),
        tear: root.querySelector('[data-unpack-tear]'),
        tearPath: root.querySelector('[data-unpack-tear] path'),
        pieces: Array.from(root.querySelectorAll('[data-unpack-beignet]')),
        sugar: Array.from(root.querySelectorAll('[data-unpack-sugar]')),
        payoff: root.querySelector('[data-unpack-payoff]'), last: -1
      };
      scenes.set(root, scene);
      if (window.ResizeObserver) {
        scene.observer = new ResizeObserver(resize);
        scene.observer.observe(stage);
      }
    });
    resize();
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', resize, { passive: true });
  window.addEventListener('pageshow', resize);
  if (reduce.addEventListener) reduce.addEventListener('change', resize);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    scenes.forEach(function (scene, root) {
      if (event.target.contains(root)) {
        if (scene.observer) scene.observer.disconnect();
        scenes.delete(root);
      }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
